import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import getCookie from '../Queries/getCookie';

// Styles
import styles from './index.module.sass';

export default function AcceptCookies({ screenSize }) {
  const { t } = useTranslation('acceptcks');
  const [showMessage, setShowMessage] = useState(true);

  useEffect(() => {
    if (
      getCookie(`cartCookie${process.env.REACT_APP_COUNTRY}`) ||
      getCookie(`cartCookie${process.env.REACT_APP_COUNTRY}`) === 'accepted'
    ) {
      setShowMessage(false);
    }
  }, []);

  function accept() {
    let CookieDate = new Date();
    CookieDate.setFullYear(CookieDate.getFullYear() + 10);
    document.cookie = `cartCookie${
      process.env.REACT_APP_COUNTRY
    }=accepted; expires=${CookieDate.toUTCString()};`;
    setShowMessage(false);
  }

  return (
    (showMessage && (
      <div className={`${styles.acceptcks} ${styles[screenSize]}`}>
        <div className={styles.textContainer}>
          <div className={styles.title}>{t('title')}</div>
          {t('text')}
        </div>
        <div className={styles.buttonsContainer}>
          <div className={styles.closeButton} onClick={() => setShowMessage(false)}>
            {t('closeButton')}
          </div>
          <div className={styles.acceptButton} onClick={accept}>
            {t('acceptButton')}
          </div>
        </div>
      </div>
    )) ||
    null
  );
}
